import {useUserContext} from '@/components/Providers/UserContext.tsx';
import ContactsIcon from '@mui/icons-material/Contacts';
import LogoutIcon from '@mui/icons-material/Logout';
import type {SxProps} from '@mui/material';
import {Button} from '@mui/material';
import Box from '@mui/material/Box';
import type * as React from 'react';
import {useNavigate} from 'react-router-dom';

type Props = {
    sx?: SxProps;
};

const UserHeaderLinks = ({sx}: Props): React.ReactElement => {
    const navigate = useNavigate();
    const {logOut} = useUserContext();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                mr: 3,
                mt: 4,
                ...sx,
            }}
        >
            <Button
                component='label'
                startIcon={<ContactsIcon />}
                onClick={() => navigate('/')}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    color: '#000',
                }}
            >
                Student Directory
            </Button>
            <Button
                component='label'
                startIcon={<LogoutIcon />}
                onClick={logOut}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    color: '#000',
                }}
            >
                Sign-Out
            </Button>
        </Box>
    );
};

export default UserHeaderLinks;
